<template>
    <u-tab-dot v-bind="$attrs">
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </u-tab-dot>
</template>

<script>
import UTabDot from "@/components/publish/styles/tabs/u-tab-dot.vue";

export default {
    props: {},
    components: {
        UTabDot,
    },
    data: () => {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
